import { useEffect } from 'react';
import { Footer, TopBar } from '../components/TopBar';

export function SubmitThanks() {
  useEffect(() => {
    document.title = 'Payment received — The Yard Sale Map';
  }, []);

  return (
    <>
      <TopBar />
      <main className="page" id="main">
        <h1>Payment received — thank you!</h1>
        <p>Your listing is being featured now. It's created by our system moments after payment, so it may take a minute or two to appear on the map.</p>
        <p>
          <a className="btn primary" href="/">
            Back to the map
          </a>
        </p>
      </main>
      <Footer />
    </>
  );
}
